import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: .5rem;
`;

export const QuestionsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
`;

export const QuestionContainer = styled.div`
  padding: 1rem;
  border-radius: .25rem;
  border: 1px solid #e2e8f0;
`;

export const ChoicesColContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: .5rem;

  > div {
    display: flex;
    align-items: center;
    gap: .5rem;
    background: #f7fafc;
    padding: 1rem 1.25rem;
  }
`;